'use strict';

const x = {
    xs: '0.25rem',
    s: '0.5rem',
    m: '1rem',
    l: '1.5rem',
    xl: '2rem',
};
const space = {
    component: {
        x,
        y: {
            xs: '0.25rem',
            s: '0.5rem',
            m: '1rem',
            l: '1.5rem',
            xl: '2rem',
            xxl: '2.5rem',
            xxxl: '3rem',
        },
    },
    layout: {
        x,
        y: {
            xs: '1rem',
            s: '1.5rem',
            m: '2rem',
            l: '3rem',
            xl: '4rem',
            xxl: '6rem',
            xxxl: '10rem',
        },
    },
    table: {
        xxxs: '0.125rem',
        xxs: '0.1875rem',
        xs: '0.3125rem',
        s: '0.5rem',
        m: '0.625rem',
        mm: '0.71875rem',
        ml: '0.75rem',
        l: '0.8125rem',
        xl: '0.875rem',
        xxl: '1rem',
    },
};

exports.space = space;
//# sourceMappingURL=spacing.js.map
